<div data-testid="signups-per-week" class="signups-per-week">
  <header class="signups-per-week__header">
    <div class="signups-per-week__titles">
      <h4 class="signups-per-week__title">Sign-ups per week</h4>
      <p *ngIf="hasWeeks" data-testid="signups-subtitle" class="signups-per-week__subtitle">{{ data.periodTotal | adbCount:'new user' }} in the period. Weeks inside it are drawn strong.</p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="signups-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or pick another period." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && !hasWeeks" data-testid="signups-empty" icon="fa-regular fa-user-plus"
                             [title]="'No sign-ups in this view'"></app-admin-dashboard-empty>
  <div *ngIf="loaded && hasWeeks" #chart data-testid="signups-chart" class="signups-per-week__chart"></div>
  <div *ngIf="!loaded" class="signups-per-week__chart"></div>
</div>
